// ⚠️⚠️⚠️⚠️ AUTO GENERATED FILE ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../../schema';

import gql from '@workspace/graphql-codegen-fetch';
export type CmsPhraseFragment = { key: string, value: string | undefined, brandOverwrites: Array<{ value: string | undefined, brand: { slug: string } | undefined }> | undefined };

export const CmsPhraseFragmentDoc = gql`
    fragment CmsPhraseFragment on CmsPhrase {
  key
  value
  brandOverwrites {
    value
    brand {
      slug
    }
  }
}
    `;